import { useEffect, useState } from "react"
import { httpSharePointRepository } from "../data/repositories/sharepoint-repository"

/**
 * Landing route for the Microsoft OAuth redirect (registered as
 * `MS_REDIRECT_URI`, e.g. http://localhost:5173/oauth-callback). Runs inside the
 * popup opened by `useSharePointAuth`: it exchanges the `code` for a
 * `connection_id` via the backend, posts it back to the opener, and closes.
 */
export const SharePointOAuthCallbackPage = () => {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get("code")
    const state = params.get("state")
    const oauthError = params.get("error_description") || params.get("error")

    if (oauthError) {
      setError(oauthError)
      return
    }
    if (!code || !state) {
      setError("Thiếu code hoặc state trong redirect.")
      return
    }

    let cancelled = false
    httpSharePointRepository
      .exchangeCode(code, state)
      .then((connectionId) => {
        if (cancelled) return
        if (window.opener) {
          window.opener.postMessage(
            { type: "sharepoint-connected", connection_id: connectionId },
            window.location.origin,
          )
        }
        window.close()
      })
      .catch((e: unknown) => {
        if (cancelled) return
        setError(e instanceof Error ? e.message : "Trao đổi mã thất bại")
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-center text-sm">
      {error ? (
        <div className="text-red-500">
          Kết nối SharePoint thất bại: {error}
          <br />
          Bạn có thể đóng cửa sổ này và thử lại.
        </div>
      ) : (
        <div className="text-muted-foreground">Đang kết nối SharePoint…</div>
      )}
    </div>
  )
}
